import React from 'react'
import { Box, Grid, Container, Link, Button, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { MyLink, TrackEvent } from '../../../components'
import { img } from '../../../imgs'
import { useReduxSelector } from '../../../hooks'

export const RulesSection: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const { auth } = useReduxSelector((state) => state.auth)
  const { REACT_APP_RULES_URL: RULES } = process.env

  const lgDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(1280))

  const onClickRules = () => {
    TrackEvent({ eventCategory: 'InteractionDoc', eventAction: 'rules' })
  }

  return (
    <Box className={classes.page}>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container direction="row" justifyContent="space-around" alignItems="center" spacing={lgDown ? 0 : 3}>
          <Grid item xs={12} md={6}>
            <Grid container justifyContent="center">
              <Grid item xs={9} sm={8} md={12} lg="auto">
                <img src={img.proKubok} alt="" className={classes.img} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5}>
            <Grid container justifyContent="center">
              <Grid item xs={11} sm={8} md={12}>
                <Box color="#D0CECE" className={classes.text}>
                  <Box mb={2}>
                    <span style={{ fontWeight: 700 }}>КУБОК IRB</span> – соревнование членов команд ресторанов Компании.
                    В нем могут принять участие сотрудники всех ресторанов IRB, которые готовы соревноваться за право
                    стать лучшими в утвержденных номинациях. КУБОК IRB проводится в 4 этапа. Участники получат памятные
                    сувениры, а победители - заслуженные призы!
                  </Box>
                  <Box mb={2}>
                    <span style={{ fontWeight: 700 }}>28 АВГУСТА</span> стартует работа платформы cup.irb.rest, где
                    сотрудники ресторанов смогут пройти регистрацию, найти информацию о каждом этапе и номинации
                    соревнований, подать заявку на участие в выбранной ими дисциплине.
                  </Box>
                  <Box mb={2}>
                    <span style={{ fontWeight: 700 }}>4 СЕНТЯБРЯ</span> начнется борьба за право стать Легендой и
                    вписать свое имя в историю КУБКА и Компании.
                  </Box>
                </Box>
                {/* <Grid container justifyContent="center"> */}
                {/*  <Grid item xs="auto" sm="auto" md={12}> */}
                {/*    {!auth && ( */}
                {/*      <Box className={classes.boxBtn}> */}
                {/*        <Button fullWidth component={MyLink} to="?signup" variant="contained" color="error"> */}
                {/*          Участвовать */}
                {/*        </Button> */}
                {/*      </Box> */}
                {/*    )} */}
                {/*  </Grid> */}
                {/* </Grid> */}
                <Grid container justifyContent="center">
                  <Grid item xs="auto" md={12}>
                    <Box className={classes.boxRules}>
                      <Link
                        href={RULES}
                        className={classes.rules}
                        onClick={onClickRules}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Pro правила
                      </Link>
                    </Box>
                    {/* <Box className={classes.boxReg}> */}
                    {/*  <Link */}
                    {/*    href="/backend/files/instruction_registarion.pdf" */}
                    {/*    className={classes.reg} */}
                    {/*    onClick={onClickRules} */}
                    {/*    target="_blank" */}
                    {/*    rel="noopener noreferrer" */}
                    {/*  > */}
                    {/*    Инструкция по регистрации */}
                    {/*  </Link> */}
                    {/* </Box> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    padding: '120px 0 100px',
    background: 'linear-gradient(#7D0A13, #1F0103) 0 0 no-repeat',
    [down('lg')]: {
      padding: '80px 0',
    },
    [down('md')]: {
      padding: '9.5vw 0',
    },
    [down('sm')]: {
      padding: '13vw 0',
    },
  },
  container: {
    [down('lg')]: {
      padding: '0 15px!important',
    },
  },
  img: {
    maxWidth: 580,
    width: '100%',
    [down('sm')]: {},
  },
  text: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 50,
    [down('lg')]: {
      fontSize: 17,
      marginBottom: 40,
    },
    [down('md')]: {
      fontSize: '2vw',
      marginTop: '6vw',
      marginBottom: '4.2vw',
    },
    [down('sm')]: {
      fontSize: '3.2vw',
      marginTop: '6vw',
      marginBottom: '10vw',
    },
  },
  link: {
    '-webkit-tap-highlight-color': 'transparent',
    color: '#D0CECE!important',
    transition: '0.3s',
    textDecorationColor: '#D0CECE!important',
    '&:hover': {
      textDecorationColor: `${palette.primary.contrastText}!important`,
    },
  },
  boxBtn: {
    width: 250,
    marginBottom: 30,
    [down('md')]: {
      width: 220,
      marginBottom: '3.1vw',
    },
    [down('sm')]: {
      marginBottom: '8vw',
    },
  },
  boxRules: {
    [down('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  boxReg: {
    marginTop: 20,
    [down('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  rules: {
    fontSize: 18,
    fontWeight: 600,
    transition: '0.3s',
    textTransform: 'uppercase',
    color: `${palette.primary.contrastText}!important`,
    textDecorationColor: 'rgb(255, 255, 255, 0.6)!important',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      textDecorationColor: `${palette.primary.contrastText}!important`,
    },
    [down('lg')]: {
      fontSize: 17,
    },
    [down('md')]: {
      fontSize: '1.9vw',
    },
    [down('sm')]: {
      fontSize: '3.1vw',
    },
  },
  reg: {
    fontSize: 17,
    fontWeight: 600,
    transition: '0.3s',
    color: `${palette.primary.contrastText}!important`,
    textDecorationColor: 'rgb(255, 255, 255, 0.6)!important',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      textDecorationColor: `${palette.primary.contrastText}!important`,
    },
    [down('lg')]: {
      fontSize: 17,
    },
    [down('md')]: {
      fontSize: '1.85vw',
    },
    [down('sm')]: {
      fontSize: '3.05vw',
    },
  },
}))
